import { render } from "./ColorTile.vue?vue&type=template&id=94234550&scoped=true"
import script from "./ColorTile.vue?vue&type=script&lang=js"
export * from "./ColorTile.vue?vue&type=script&lang=js"

import "./ColorTile.vue?vue&type=style&index=0&id=94234550&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-94234550"

export default script